import { render } from "./monthNavigator.vue?vue&type=template&id=03f3c4f2&ts=true"
import script from "./monthNavigator.vue?vue&type=script&lang=ts"
export * from "./monthNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__